import apiClient from './apiClient';
import type {
    Disclaimer,
    CreateDisclaimerDto,
    UpdateDisclaimerDto,
} from '../types/types';

const disclaimersService = {
    getAll: async (): Promise<Disclaimer[]> => {
        const res = await apiClient.get<Disclaimer[]>('/disclaimers');
        return res.data;
    },

    getById: async (id: number): Promise<Disclaimer> => {
        const res = await apiClient.get<Disclaimer>(`/disclaimers/${id}`);
        return res.data;
    },

    create: async (dto: CreateDisclaimerDto): Promise<Disclaimer> => {
        const res = await apiClient.post<Disclaimer>('/disclaimers', dto);
        return res.data;
    },

    update: async (id: number, dto: UpdateDisclaimerDto): Promise<Disclaimer> => {
        const res = await apiClient.put<Disclaimer>(`/disclaimers/${id}`, dto);
        return res.data;
    },

    remove: async (id: number): Promise<{ message: string }> => {
        const res = await apiClient.delete<{ message: string }>(`/disclaimers/${id}`);
        return res.data;
    },
};

export default disclaimersService;
